export default {
  'app.setting.pagestyle': 'Настройка стиля страницы',
  'app.setting.pagestyle.dark': 'Тёмный стиль',
  'app.setting.pagestyle.light': 'Светлый стиль',
  'app.setting.content-width': 'Ширина контента',
  'app.setting.content-width.fixed': 'Фиксированная',
  'app.setting.content-width.fluid': 'Адаптивная',
  'app.setting.themecolor': 'Цвет темы',
  'app.setting.themecolor.dust': 'Тёмно-красный',
  'app.setting.themecolor.volcano': 'Вулкан',
  'app.setting.themecolor.sunset': 'Оранжевый закат',
  'app.setting.themecolor.cyan': 'Голубой',
  'app.setting.themecolor.green': 'Полярный зелёный',
  'app.setting.themecolor.daybreak': 'Рассветно-голубой (по умолчанию)',
  'app.setting.themecolor.geekblue': 'Тёмно-синий',
  'app.setting.themecolor.purple': 'Золотисто-фиолетовый',
  'app.setting.navigationmode': 'Режим навигации',
  'app.setting.sidemenu': 'Боковое меню',
  'app.setting.topmenu': 'Верхнее меню',
  'app.setting.fixedheader': 'Фиксированный заголовок',
  'app.setting.fixedsidebar': 'Фиксированная боковая панель',
  'app.setting.fixedsidebar.hint': 'Работает в режиме бокового меню',
  'app.setting.hideheader': 'Скрывать заголовок при прокрутке',
  'app.setting.hideheader.hint': 'Работает, когда скрытие заголовка включено',
  'app.setting.othersettings': 'Другие настройки',
  'app.setting.weakmode': 'Режим для дальтоников',
  'app.setting.copy': 'Копировать настройки',
  'app.setting.copyinfo':
    'Настройки скопированы, замените defaultSettings в src/models/setting.js',
  'app.setting.production.hint':
    'Панель настроек отображается только в режиме разработки',
};
